import { render, staticRenderFns } from "./checkbox-modal-slots.mpx?vue&type=template&id=fa0306b8&isComponent&outputPath=components%2Fcheckbox-modal-slotsa654863c%2Findex"
import script from "./checkbox-modal-slots.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fcheckbox-modal-slotsa654863c%2Findex"
export * from "./checkbox-modal-slots.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fcheckbox-modal-slotsa654863c%2Findex"
import style0 from "./checkbox-modal-slots.mpx?vue&type=style&index=0&id=fa0306b8&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_a654863c%22%7D&isComponent&outputPath=components%2Fcheckbox-modal-slotsa654863c%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports